import {quarterOptions} from "@/common/define";

export class TeamLeadIndex {
    constructor(record) {
        this.id = record.id;
        this.description = record.description ?? '';
        this.department = record.department?.name;
        this.quarter = this.getQuarter(record.quarter, record.year);
        this.human = this.getHuman(record.user);
        this.status = record.status;
        this.statusLabel = this.getStatusLabel(record.status);
        this.bgStatus = this.getBgStatus(record.status);
    }

    getQuarter(value, year) {
        if (!value || !year) return ''
        return `${quarterOptions[value-1].label}/${year}`
    }

    getStatusLabel(value) {
        switch (value) {
            case 1:
                return 'Đạt'
            case 2:
                return 'Không đạt'
            default:
                return ''
        }
    }

    getHuman(user) {
        if (!user) return ''
        if (user && user.id && user.name !== '') {
            return `${user.name} - ${user.id + 100000}`
        }
    }

    getBgStatus(value) {
        switch (value) {
            case 1:
                return 'status-green'
            case 2:
                return 'status-red'
            default:
                return ''
        }
    }
}

export const statusOptions = [
    {
        id: 1,
        name: "Đạt"
    },
    {
        id: 2,
        name: "Không đạt"
    }
]